/**
 * E:\SVNProject\Ipolloverse\Editor\sceneEditor\src\3dlibs\command\command
 * @description 历史记录的操作的基类，子类需要继承execute函数、undo函数和clear函数
 * @author TKB
 * @creat 2023-03-06 11:55:53
 */
export class BaseCommand {
  constructor() {
    this.type = "cmd"; //指示当前操作的类型，比如“transform”、“copy”等，主要用于调试

    this.debug = false; //是否打开调试
  }

  /**
   * 重做
   */
  redo() {
    if (this.debug) console.log(this.type + ":redo");
  }

  /**
   * 撤销操作
   */
  undo() {
    if (this.debug) console.log(this.type + ":undo");
  }

  clear() {}

  /**
   * 用于调试
   */
  printInfo() {
    console.log("this is " + this.type);
  }
}
